import * as React from "react";
import {HashRouter} from "react-router-dom";
import {Provider} from "react-redux";
import { ConfigProvider, Layout } from "antd";
import enUS from 'antd/es/locale/en_US';
import {route} from "./routes";
import { configureStore, initStore } from "./store/configStore";
import UserContext from "../contexts/UserContext";
import useUser from "../contexts/useUser";
import { getProfile } from "./pages/Profile/api";

const store = configureStore();
store.dispatch<any>(initStore());

function App() {
    const user = useUser();
    const [loading, setLoading] = React.useState(true);
    const [userId, setUserId] = React.useState('');

    React.useEffect(() => {
        const intervalHandle = setInterval(() => {
            if (window.userId && window.userId !== '') {
                setUserId(window.userId);
                clearInterval(intervalHandle);
            }
        }, 1000);
    }, []);

    React.useEffect(() => {
        if (userId.length > 0) {
            (async function() {
                const prf = await getProfile(userId);
                user.setUser(prf);
            })();
            setLoading(false);
        }
    }, [userId])

    if (loading) {
        return <Layout className="ant-layout-has-sider">
            <Layout>
                <Layout.Content>
                    Loading {JSON.stringify(window.userId)}
                </Layout.Content>
            </Layout>
        </Layout>
    }

    return (
        <ConfigProvider locale={enUS}>
            <Provider store={store}>
                <UserContext.Provider value={user}>
                    <HashRouter children={route} />
                </UserContext.Provider>
            </Provider>
        </ConfigProvider>
    );
}

export default App;
